import * as firebase from "firebase/app";
import "firebase/database";
import "firebase/storage";

import { BRAND_CREATE, BRAND_FETCH, BRAND_UPDATE } from "./types";

export const spareBrandDeleteById = (id, oldImg) => {
  return (dispatch) => {
    firebase
      .database()
      .ref("spare_brands/" + id)
      .remove()
      .then(() => {
        // ===Reorder Brand===
        firebase
          .database()
          .ref("spare_brands")
          .once("value", (snapshot) => {
            let data2 = [];
            snapshot.forEach((childSnapshot) => {
              data2.push(childSnapshot.val());
            });
            data2.sort((a, b) =>
              Number(a.order) > Number(b.order)
                ? 1
                : Number(b.order) > Number(a.order)
                ? -1
                : 0
            );
            let run = 1;
            data2.forEach((item) => {
              if (typeof item === "object") {
                firebase
                  .database()
                  .ref("spare_brands/" + item.id)
                  .update({ order: run });
                run++;
              }
            });
            setTimeout(() => removeOldFile(oldImg), 1000);
          });
        // ===Reorder Brand===
      });
  };
};

const removeOldFile = (src) => {
  var ref = firebase.storage().ref().child(src);
  // Delete the file
  ref
    .delete()
    .then(() => {
      window.location = "/admin/spare";
    })
    .catch((error) => {
      window.location = "/admin/spare";
    });
};

const spareBrandCheckOrder = (id, order, oldOrder) => {
  return new Promise((resolve) => {
    firebase
      .database()
      .ref("spare_brands")
      .once("value", (snapshot) => {
        let data = [];
        snapshot.forEach((childSnapshot) => {
          let item = childSnapshot.val();
          if (typeof item === "object") {
            item.order = Number(item.order);
            data.push(item);
          }
        });
        data.sort((a, b) =>
          a.order > b.order ? 1 : b.order > a.order ? -1 : 0
        );
        oldOrder = Number(oldOrder);
        order = Number(order);
        if (oldOrder > order) {
          let run = Number(order) + 1;
          data.forEach((item) => {
            if (
              item.order < oldOrder &&
              item.order >= order &&
              item.id !== id
            ) {
              firebase
                .database()
                .ref("spare_brands/" + item.id)
                .update({ order: run });
              run++;
            }
          });
          setTimeout(() => resolve(true), 1000);
        } else if (oldOrder < order) {
          let run = Number(oldOrder);
          data.forEach((item) => {
            if (
              item.order > oldOrder &&
              item.order <= order &&
              item.id !== id
            ) {
              firebase
                .database()
                .ref("spare_brands/" + item.id)
                .update({ order: run });
              run++;
            }
          });
          setTimeout(() => resolve(true), 1000);
        }
      });
  });
};

export const spareBrandUpdateById = (id, data, oldImg, oldOrder) => {
  return (dispatch) => {
    dispatch({ type: BRAND_UPDATE, payload: true });
    if (data.img) {
      const filename = Date.now() + "." + data.img.name.split(".").pop();
      // Upload File to firebase storage
      const storage = firebase.storage().ref();
      const fileRef = storage.child("spare_brand/" + filename);
      fileRef.put(data.img).then(() => {
        fileRef
          .getDownloadURL()
          .then((url) => {
            data.img = url;
            firebase
              .database()
              .ref("spare_brands/" + id)
              .update(data)
              .then(async (res) => {
                const chk = await spareBrandCheckOrder(
                  id,
                  data.order,
                  oldOrder
                );
                if (chk) {
                  removeOldFile(oldImg);
                }
              })
              .catch((err) => {
                dispatch({ type: BRAND_UPDATE, payload: false });
              });
          })
          .catch((err) => {
            dispatch({ type: BRAND_UPDATE, payload: false });
          });
      });
    } else {
      delete data.img;
      firebase
        .database()
        .ref("spare_brands/" + id)
        .update(data)
        .then(async (res) => {
          if (data.order !== oldOrder) {
            const chk = await spareBrandCheckOrder(id, data.order, oldOrder);
            if (chk) {
              window.location = "/admin/spare";
            }
          } else {
            window.location = "/admin/spare";
          }
        })
        .catch((err) => dispatch({ type: BRAND_UPDATE, payload: false }));
    }
  };
};

export const spareBrandFetch = () => {
  return (dispatch) => {
    let brandsRef = firebase.database().ref("spare_brands");
    brandsRef.once("value", (snapshot) => {
      let data = [];
      snapshot.forEach((childSnapshot) => {
        let item = childSnapshot.val();
        if (typeof item === "object") {
          item.order = Number(item.order);
          data.push(item);
        }
      });
      data.sort((a, b) => (a.order > b.order ? 1 : b.order > a.order ? -1 : 0));
      dispatch({ type: BRAND_FETCH, payload: data });
    });
  };
};

export const spareBrandFetchById = (id) => {
  return (dispatch) => {
    let brandsRef = firebase.database().ref("spare_brands").child(id);
    brandsRef.once("value", (snapshot) => {
      const data = snapshot.val();
      dispatch({ type: BRAND_FETCH, payload: [data] });
    });
  };
};

export const spareBrandCreate = (data) => {
  return (dispatch) => {
    dispatch({ type: BRAND_CREATE, payload: true });
    const filename = Date.now() + "." + data.img.name.split(".").pop();
    const storage = firebase.storage().ref();
    const fileRef = storage.child("spare_brand/" + filename);
    fileRef.put(data.img).then(() => {
      fileRef
        .getDownloadURL()
        .then((url) => {
          const brandsRef = firebase.database().ref("spare_brands").push();
          const id = brandsRef.key;
          data.id = id;
          data.img = url;
          brandsRef
            .set(data)
            .then((response) => {
              // ===Reorder Brand===
              firebase
                .database()
                .ref("spare_brands")
                .once("value", (snapshot) => {
                  let data2 = [];
                  snapshot.forEach((childSnapshot) => {
                    data2.push(childSnapshot.val());
                  });
                  data2.sort((a, b) =>
                    Number(a.order) > Number(b.order)
                      ? 1
                      : Number(b.order) > Number(a.order)
                      ? -1
                      : 0
                  );
                  data2.splice(
                    data2.findIndex((e) => e.id === data.id),
                    1
                  );
                  let run = 2;
                  data2.forEach((item) => {
                    if (typeof item === "object") {
                      firebase
                        .database()
                        .ref("spare_brands/" + item.id)
                        .update({ order: run });
                      run++;
                    }
                  });
                  setTimeout(() => (window.location = "/admin/spare"), 1000);
                });
              // ===Reorder Brand===
            })
            .catch((err) => {
              console.log("brandCreate", err);
            });
        })
        .catch((error) => {
          dispatch({ type: BRAND_CREATE, payload: false });
          console.log("Fail to create brand", error);
        });
    });
  };
};
